import React, { useMemo } from 'react';
import { View } from 'react-native';
const flexStyles = function flexStyles(props) {
    return {
        ...(props?.flexCol ? { flexDirection: 'column' } : {}),
        ...(props?.flexRow ? { flexDirection: 'row' } : {}),
    };
};
const Box = React.forwardRef((props, ref) => {
    const { style, ...restProps } = props;
    const flattenedStyle = useMemo(() => ([style, flexStyles(props)]), [props.flexCol, props.flexRow, props.style]);
    return (<View style={flattenedStyle} ref={ref} {...restProps}>
      {props.children}
    </View>);
});
// [TODO] Address warning on Mobile
// Disable PropType warnings on dev
// @ts-ignore
View.propTypes = undefined;
export default Box;
//# sourceMappingURL=Box.js.map